import { useTheme } from '@mui/material';
import { Appearance, StripeElementsOptions } from '@stripe/stripe-js';
import { useMemo } from 'react';

const FONTS = [
  {
    cssSrc:
      'https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap',
  },
];

function useStripeOptions({
  clientSecret,
}: {
  clientSecret?: string;
} = {}) {
  const theme = useTheme();

  const appearance: Appearance = useMemo<Appearance>(
    () => ({
      labels: 'floating',
      variables: {
        colorPrimary: theme.palette.primary.main,
        colorDanger: theme.palette.primary.main,
        colorBackground: '#ffffff',
        colorText: theme.palette.darkGrey.main,
        fontFamily: 'Montserrat',
        borderRadius: '5px',
        spacingUnit: '4px',
        fontSizeBase: '16px',
        fontWeightBold: '700',
        fontWeightLight: '400',
        colorTextPlaceholder: theme.palette.outlineGrey.main,
      },
      rules: {
        '.Label': {
          color: theme.palette.outlineGrey.main,
        },
        '.Input': {
          borderColor: theme.palette.outlineGrey.main,
        },
      },
    }),
    [theme],
  );

  const options = useMemo<StripeElementsOptions>(
    () => ({
      appearance,
      fonts: FONTS,
      clientSecret,
    }),
    [appearance, clientSecret],
  );

  return options;
}

export default useStripeOptions;
